import type { FillLayerSpecification, VectorSourceSpecification } from 'mapbox-gl';

export const BD_POSTAL_CODE_SOURCE_ID = 'postal-codes';
export const BD_POSTAL_CODE_LAYER_NAME = 'postal-codes';
export const BD_POSTAL_CODE_HIGHLIGHTED_LAYER_NAME = 'postal-codes-highlighted';

export const BD_POSTAL_CODES_LAYER_CONFIG: FillLayerSpecification = {
  id: BD_POSTAL_CODE_LAYER_NAME,
  type: 'fill',
  source: BD_POSTAL_CODE_SOURCE_ID,
  'source-layer': 'postal_codes-2q9j3t',
  paint: {
    'fill-outline-color': 'rgba(0,0,0,0.3)',
    'fill-color': 'rgba(0,0,0,0.1)',
  },
};

export const BD_POSTAL_CODES_LAYER_HIGHLIGHTED_CONFIG: FillLayerSpecification =
  {
    id: BD_POSTAL_CODE_HIGHLIGHTED_LAYER_NAME,
    type: 'fill',
    source: BD_POSTAL_CODE_SOURCE_ID,
    'source-layer': 'postal_codes-2q9j3t',
    paint: {
      'fill-outline-color': '#484896',
      'fill-color': '#6e599f',
      'fill-opacity': 0.75,
    },
    filter: ['in', 'plz', ''],
  };

export const BD_POSTAL_CODES_SOURCE: VectorSourceSpecification = {
  type: 'vector',
  url: 'mapbox://sseemann.d2edzmbo',
};

export interface BD_POSTAL_CODES_SOURCE_FEATURE_PROPERTIES {
  plz: string;
  note: string;
}
